import { getPots, } from 'features/pots/actions';
import { CALL_API } from 'middleware/api';
/**
 * `GET /wealth/pots`, `POST /wealth/pots` and `GET /wealth/trading/accounts` also
 * return wealth-level data (e.g. `isaAllowance`), so the wealth reducer listens to
 * the same success actions.
 */
export { getPots };
/**
 * Fetches the ISA allowance. Handled by the wealth saga with `takeLeading`,
 * so calls made while a request is in flight are ignored.
 */
export const fetchIsaAllowance = () => ({
    type: 'FETCH_ISA_ALLOWANCE',
});
/**
 * `GET /wealth/isa-status`
 * Dispatch `fetchIsaAllowance()` instead, so concurrent calls are deduped.
 */
export const getIsaAllowance = () => ({
    [CALL_API]: {
        endpoint: '/wealth/isa-status',
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            'GET_ISA_ALLOWANCE_REQUEST',
            'GET_ISA_ALLOWANCE_SUCCESS',
            'GET_ISA_ALLOWANCE_FAILURE',
        ],
    },
});
